import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";

import course05 from "../../../course/course-05/course";
import lesson0503 from "../lesson-03/lesson";
import lesson0508 from "../lesson-08/lesson";
import lesson0521 from "../lesson-21/lesson";
import lesson0522 from "../lesson-22/lesson";
import lesson0523 from "../lesson-23/lesson";
import lesson0524 from "../lesson-24/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "0aaa218a-03c6-4fa4-a8ec-5dc28a0f819b",
    course: {
      id: course05.id,
      slug: course05.slug as string,
      name: course05.name,
      publicId: course05.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course05, lesson0503),
    lesson: lesson0503,
  },
  {
    id: "fd6f1381-05f3-4861-b66b-70763f3fcc3f",
    course: {
      id: course05.id,
      slug: course05.slug as string,
      name: course05.name,
      publicId: course05.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course05, lesson0508),
    lesson: lesson0508,
  },
  {
    id: "fab96e8e-aa28-4f07-a692-8258d872c07f",
    course: {
      id: course05.id,
      slug: course05.slug as string,
      name: course05.name,
      publicId: course05.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course05, lesson0521),
    lesson: lesson0521,
  },
  {
    id: "1d5791f0-202e-4652-b905-dd0c3a4c65ef",
    course: {
      id: course05.id,
      slug: course05.slug as string,
      name: course05.name,
      publicId: course05.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course05, lesson0522),
    lesson: lesson0522,
  },
  {
    id: "304ce8fa-4561-4616-8f2c-97e627cec259",
    course: {
      id: course05.id,
      slug: course05.slug as string,
      name: course05.name,
      publicId: course05.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course05, lesson0523),
    lesson: lesson0523,
  },
  {
    id: "56acb110-17ed-44d5-9255-46b4ce9c1aee",
    course: {
      id: course05.id,
      slug: course05.slug as string,
      name: course05.name,
      publicId: course05.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course05, lesson0524),
    lesson: lesson0524,
  },
];

export default lessonLinks;
